// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mO-l","left":"styles_left__gbpew"};